import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { cn } from "@omni/utils/styles";

import { Anchor } from "@/components/General/Anchor/anchor.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { getHomeDeliveryKey } from "@/utils/deliveryPromise";

import { useDeliveryItemContext } from "../../context/deliveryItem.context";

const HomeDeliveryComponent = () => {
    const { t } = useGranite();
    const { option, minimumOrderQuantity, roundingValue, xfPath } =
        useDeliveryItemContext();

    if (option.deliveryType !== DeliveryType.HomeDelivery) {
        return null;
    }

    const deliveryTimeUnitTk = t(
        `product.deliveryPromise.timeUnits.${option.deliveryTimeUnit}`
    );

    return (
        <div className={cn("tw:pl-5.25")}>
            {
                <p
                    data-test={`deliveryItem-${option.deliveryType}-deliveryPromise`}
                    className={cn("tw:text-sm tw:font-light tw:m-0")}
                >
                    {t(
                        getHomeDeliveryKey("pdp") || "",
                        option.deliveryTime,
                        deliveryTimeUnitTk,
                        option.realTimeStock
                    )}
                </p>
            }
            {minimumOrderQuantity > 1 && (
                <div>
                    {roundingValue > 1 ? (
                        <p
                            data-test={`deliveryItem-${option.deliveryType}-roundingValue`}
                            className={cn("tw:text-sm tw:font-light tw:m-0")}
                        >
                            {t(
                                "general.ecommerce.roundingValue",
                                roundingValue
                            )}
                        </p>
                    ) : (
                        <p
                            data-test={`deliveryItem-${option.deliveryType}-minimumOrderQuantity`}
                            className={cn("tw:text-sm tw:font-light tw:m-0")}
                        >
                            {t(
                                "general.ecommerce.minimumOrderQuantity",
                                minimumOrderQuantity
                            )}
                        </p>
                    )}
                </div>
            )}
            {xfPath && (
                <Anchor
                    color={"link"}
                    data-test={`deliveryItem-${option.deliveryType}-supplierInformation`}
                    className={cn("tw:text-sm! tw:p-0 tw:font-light tw:m-0")}
                    href={"#supplier-info"}
                >
                    {t("ecommerce.label.supplierInformation")}
                </Anchor>
            )}
        </div>
    );
};

export { HomeDeliveryComponent };
